<template>
    <v-card flat>
        <v-card-title>
            Listado
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
            </v-text-field>
        </v-card-title>

        <v-data-table :headers="headers" :items="utilidades" :search="search" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc">
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editUtilidad(item.id_utilidad)">mdi-pencil</v-icon>
                <v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>

        <v-dialog v-model="dialogDelete" persistent max-width="500px">
            <v-card>
                <v-card-title class="text-h5">
                    {{ itemToDelete.nombre }}
                </v-card-title>
                <v-card-text>¿Estás seguro de querer borrar el Utilidad?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="dialogDelete = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" text @click="deleteUtilidad(itemToDelete.id_utilidad)">
                        Borrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapMutations } from "vuex";
import UtilidadesDataService from "@/services/UtilidadesDataService";

export default {
    name: "UtilidadesList",
    data: () => ({
        utilidades: [],
        search: '',
        sortBy: 'nombre',
        sortDesc: false,
        headers: [
            { text: 'Nombre', value: 'nombre' },
            { text: "Actions", value: "actions", sortable: false },
        ],
        dialogDelete: false,
        itemToDelete: {},
    }),
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        retrieveUtilidades() {
            UtilidadesDataService.getAll()
                .then((response) => {
                    // console.log("UTILIDADES"); console.log(response.data);
                    this.utilidades = response.data.map(this.getDisplayUtilidad);
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        editUtilidad(id) {
            this.$router.push({ name: "UtilidadId", params: { id: id } });
        },
        deleteUtilidad(id) {
            UtilidadesDataService.delete(id)
                .then(() => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.retrieveUtilidades();
                    this.dialogDelete = false
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
        getDisplayUtilidad(utilidad) {
            return {
                id_utilidad: utilidad.id_utilidad,
                nombre: utilidad.nombre,
            };
        },
        showDeleteDialog(item) {
            this.itemToDelete = item
            this.dialogDelete = !this.dialogDelete
        },
    },
    mounted() {
        this.retrieveUtilidades();
    }
};
</script>